import owd from 'owd/owd';

export default class setActiveTicketsPage extends owd.Component {
	init() {
        this.items = this.$element.find('.tickets-menu-item');
        this.mobileItems = this.$element.find('.tickets-mobile-item')
        this.initialSlide = $('[data-slider-initial-slide]').data('slider-initial-slide');
        this.initialSlide = this.initialSlide ? this.initialSlide - 1 : 0;
        this.done = false;
        this.bind();
    }

	bind() {
        this.on('load ajaxload', this.dom.$window, () => {
            if (window.innerWidth < 1200 && window.innerWidth > 767) {
                if (!this.done) {
                    this.items.eq(this.initialSlide).trigger('click');
                    this.done = true;
                }
            }

            if (window.innerWidth < 768) {
                if (!this.done) {

                    this.mobileItems.eq(this.initialSlide).trigger('click');
                    this.done = true;
                }
            }
        })
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('set-active-tickets-page', {
	component: setActiveTicketsPage
});